import Spinner from "../../../components/Spinner";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../redux/rootReducers";
import Button from "../../../components/forms/ButtonEx";
import Pagination from "../../../components/data/Pagination";
import paramsToObject from "../../../helpers/paramsToObject";
import { Link, useLocation, useNavigate } from "react-router-dom";
import PageWrapper from "../../../components/layouts/PageWrapper";
import { DataTableWrapper } from "../../../components/data/DataTable";
import { InputWrapper } from "../../../components/forms/FormComponents";
import { BootstrapGrid } from "../../../components/layouts/BootstrapGrid";
import { getBookingAsync } from "../../../redux/reducers/bookings/actions";
import moment from "moment";
import XrButtonAv from "../../../components/XrButtonAv";

const BookingsPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  
  const meta = useSelector((state: RootState) => state.booking.meta)
  const isLoading = useSelector((state: RootState) => state.booking.isLoading);
  const bookings = useSelector((state: RootState) => state.booking.bookings);

  const [txtSearch , setTxtSearch] = useState<string>('');
  const [searchQuery, setSearchQuery] = useState<string>('');

  const populateData = () => {
    const params = paramsToObject(location.search);
    const pageNumber = parseInt(params && params.page ? params.page : 1);
    if (pageNumber && !isNaN(pageNumber)) {
      dispatch(getBookingAsync.request({ page: pageNumber }));
    } else {
      navigate(`/bookings`);
    }
  };

  useEffect(() => {
    populateData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search, searchQuery]);

  const onChangeTxtSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setTxtSearch(e.target.value);
  }

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setSearchQuery(txtSearch);
    }, 1000);
    return () => clearTimeout(timeoutId);
  }, [txtSearch]);

  const renderBookingList = () => {
    if (isLoading) {
      return (
        <tr>
          <td colSpan={6} className="tablewrapper--loading">
            <div className="tablewrapper--loading--caption">
              <Spinner size="small" />
              <span>Memuat data...</span>
            </div>
          </td>
        </tr>
      );
    }

    if (bookings.length > 0) {
      return bookings.map(booking => {
        return (
          <tr key={booking.id}>
            <td><Link to={`/building-management/bookings/${booking.id}`}>{booking.description}</Link></td>
            <td>{moment(booking.start_date).format('DD MMM YYYY')}</td>
            <td>{moment(booking.start_date).format('HH:MM:SS')}</td>
            <td>{moment(booking.end_date).format('HH:MM:SS')}</td>
            <td>{booking.user_detail?.name}</td>
          </tr>
        );
      })
    } else {
      return (
        <tr>
          <td colSpan={7}>No booking data was found</td>
        </tr>
      );
    }
  }

  return (
    <PageWrapper>
      <BootstrapGrid>
        <div className="row">
          <div className="col-lg-12">
            <XrButtonAv href='/building-management/bookings/report-users' size='large' noBlock caption='Form User' />&nbsp;
            <XrButtonAv href='/building-management/bookings/report-security' size='large' noBlock caption='Form Security' />
          </div>
        </div>
        <div className="row">
          <div className="col-lg-8">
            <DataTableWrapper>
              <div className="tablewrapper--title">
                Cari Peminjaman
              </div>
              <div className="tablewrapper--table">
                <table>
                  <tbody>
                    <tr>
                      <td>
                        <InputWrapper disabled={isLoading} noSpace>
                          <div className="input--field no--label">
                            <input
                              type="text"
                              value={txtSearch}
                              disabled={isLoading}
                              onChange={onChangeTxtSearch}
                              placeholder="Masukan deskripsi kegiatan disini"
                            />
                          </div>
                        </InputWrapper>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </DataTableWrapper>
            <DataTableWrapper>
              <div className="tablewrapper--title">
                Daftar Peminjaman
              </div>
              <div className="tablewrapper--table">
                <table>
                  <thead>
                    <tr>
                      <th>Deskripsi</th>
                      <th>Tanggal</th>
                      <th>Mulai</th>
                      <th>Selesai</th>
                      <th>PIC</th>
                    </tr>
                  </thead>
                  <tbody>
                    {renderBookingList()}
                  </tbody>
                </table>
              </div>
              <Pagination
                isLoading={isLoading}
                totalItem={meta.total}
                listPerPage={meta.per_page}
                currentIndex={meta.current_page}
                url='bookings?page='
              />
            </DataTableWrapper>
          </div>
          <div className="col-lg-4">
          </div>
        </div>
      </BootstrapGrid>
    </PageWrapper>
  );
}

export default BookingsPage;